import { computed, ref } from 'vue';
import { useCommonStore } from '../stores/common';
import useClipboard from 'vue-clipboard3';

export default function useToastCopy() {
  const isToast = ref(false);
  const { toClipboard } = useClipboard();

  const openToast = async (text) => {
    await toClipboard(text)
    if (!isToast.value) {
      isToast.value = true;
      setTimeout(() => {
        isToast.value = false;
      }, 1000);
    }
  };
  
  const closeToast = () => {
    isToast.value = false;
  }

  return { isToast, openToast, closeToast };
}
